var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 28.43V5C90 3.67 89.47 2.4 88.54 1.46C87.61 0.52 86.33 0 85 0H15C12.24 0 10 2.24 10 5V28.43C10 40.45 14.68 51.75 23.18 60.25L32.93 70L23.18 79.75C14.68 88.26 10 99.55 10 111.57V135.01C10 136.34 10.53 137.61 11.46 138.55C12.39 139.49 13.67 140.01 15 140.01L85 140C87.76 140 90 137.76 90 135V111.56C90 99.54 85.32 88.24 76.82 79.74L67.07 70L76.82 60.24C85.32 51.75 90 40.45 90 28.43Z",
    fill: "#A3DCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C2.24 10 0 7.77 0 5C0 2.25 2.24 0 5 0H95C97.76 0 100 2.24 100 5C100 7.76 97.76 10 95 10H5ZM95 140H5C2.25 140 0 137.75 0 135C0 132.25 2.25 130 5 130H95C97.75 130 100 132.25 100 135C100 137.75 97.75 140 95 140Z",
    fill: "#0062D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V28.43C20 37.78 23.64 46.56 30.25 53.18C30.25 53.18 50 68.68 50 70C50 68.68 69.75 53.17 69.75 53.17C76.36 46.56 80 37.77 80 28.43V20H20ZM20 130V121.57C20 112.22 23.64 103.44 30.25 96.82C30.25 96.83 50 81.32 50 80C50 81.32 69.75 96.83 69.75 96.83C76.36 103.44 80 112.23 80 121.58V130H20Z",
    fill: "#7AC8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95 130H90V111.56C90 99.5402 85.32 88.2402 76.82 79.7402L74.73 77.6602C65.62 87.4802 60 100.58 60 115C60 124.01 62.22 132.49 66.07 140H95C97.75 140 100 137.75 100 135C100 132.25 97.75 130 95 130Z",
    fill: "#E6F6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 160C139.853 160 160 139.853 160 115C160 90.1472 139.853 70 115 70C90.1472 70 70 90.1472 70 115C70 139.853 90.1472 160 115 160Z",
    fill: "#007BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 135C128.673 135 127.401 134.475 126.46 133.54L111.46 118.54C110.526 117.598 110.002 116.326 110 115V95C110 92.24 112.24 90 115 90C117.76 90 120 92.24 120 95V112.93L133.54 126.47C135.49 128.42 135.49 131.59 133.54 133.54C132.599 134.475 131.327 135 130 135Z",
    fill: "#E6F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.9170f71a46603286b950a14ac62b0c50.svg";
export { ForwardRef as ReactComponent };